import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { DispatchFunction, IMyProfile, IMyProfileGrants, IGrants } from '@app/models';
import { PROFILE_LOADING, GET_MY_PROFILE, GET_MY_PROFILE_GRANTS } from '@app/store/constants';
import { myProfileService } from '@app/services';

export function handleGetProfileData(): DispatchFunction {
    return ((dispatch: Dispatch) => {
        dispatch(profileLoading(true));
        myProfileService.getMyProfile()
            .then((response: AxiosResponse) => {
                const profile = response.data;

                dispatch(getMyProfile(profile));

                myProfileService.getMyProfileWithGrants()
                    .then((response: AxiosResponse) => {
                        dispatch(getMyProfileGrants(response.data));
                        dispatch(profileLoading(false));
                    });
            });
    });
}

export function getMyProfile(myProfile: IMyProfile) {
    return {
        payload: myProfile,
        type: GET_MY_PROFILE
    };
}

export function getMyProfileGrants(myProfileGrants: IMyProfileGrants) {
    myProfileGrants.Grants.forEach(function (d: IGrants) {
        if (d.Thumbprint !== undefined && d.Thumbprint !== '') {
            d.ThumbprintAsObject = JSON.parse(d.Thumbprint);
        }
    });

    return {
        payload: myProfileGrants,
        type: GET_MY_PROFILE_GRANTS
    };
}

export function profileLoading(loading: boolean) {
    return {
        payload: loading,
        type: PROFILE_LOADING
    };
}